import { Component, Input, OnInit } from '@angular/core';
import { IFundChart } from '../../../models/fund-chart.model';
import { AreaChartComponent } from '../../../../../shared/components/area-chart/area-chart.component';

@Component({
  selector: 'app-nav-chart',
  standalone: true,
  imports: [AreaChartComponent],
  templateUrl: './nav-chart.component.html',
  styleUrl: './nav-chart.component.scss',
})
export class NavChartComponent implements OnInit {
  @Input() data: IFundChart[];
  @Input() finalPrice?: boolean;
  @Input() statisticLabel? = 'آماری';
  @Input() selectedPeriod? = 'sixMonth';
  labels: string[] = [];
  chartData = [];
  GOLD = 'Gold';

  ngOnInit(): void {
    this.data.forEach((item) => {
      this.labels.push(item.date);
      const chartItems = this.finalPrice
        ? { statisticalNav: item.statisticalNav }
        : {
            issueNav: item.issueNav,
            cancelNav: item.cancelNav,
            statisticalNav: item.statisticalNav,
          };
      this.chartData.push(chartItems);
    });
  }
}
